import SyAccordion from "./sy-accordion";

export default SyAccordion